module.exports = "/_next/static/images/a9211407e5a3a65d0c787201fa3ec0a1-holding-card-vertical@2x.png.webp";